<template>
  <section id="login">
    <br>
    <div class="columns">
      <div class="column is-4">
      </div>
      <div class="column is-4">
        <div class="card">

          <div class="card" id="verzuimtelaat">
            <header class="card-header">
              <p class="card-header-title">
                EFO Administratie wachtwoord opvragen
              </p>
            </header>
            <div class="card-content">
              <section>
                <template v-if="showrecovery">
                  <b-field label="Gebruikersnaam" prop="username">
                    <b-input v-model="form.username"></b-input>
                  </b-field>
                  <button class="button is-primary" @click="Recover">Opvragen</button>
                </template>
                <template v-else>

                  <a class="button is-text" @click="Back()">Hoofpagina</a>

                </template>

                <el-alert v-if="showerror" title="Gebruikersnaam bestaat niet!" type="error" show-icon style="display:;">
                </el-alert>

              </section>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
      </div>
    </div>
  </section>

  <!-- <el-row id="recover" type="flex" justify="center">
  <el-col :span="10" v-loading.fullscreen="loading" element-loading-text="Wachtwoord opvragen ...">
    <el-card>
      <div slot="header" class="clearfix" style="background-color:#1D8CE0;">
        <span style="line-height: 0px"><center><h2>EFO Administratie wachtwoord opvragen</h2></center></span>
      </div>
      <template v-if="showrecovery">
        <el-form ref="form" :model="form" label-width="135px">
        <el-form-item label="Gebruikersnaam" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="Recover">Opvragen</el-button>
        </el-form-item>
        </el-form>
    </template>
    <template v-else>
      <el-form ref="form" :model="form" label-width="135px">
        <el-form-item>
          <el-button type="text" @click="Back">Terug naar Login scherm.</el-button>
        </el-form-item>
      </el-form>
    </template>
<el-alert v-if="showsuccess" title="Wachtwoord is successvol gestuurd naar de geregistreerde e-mail adres!" type="success" show-icon style="display:;">
</el-alert>
<el-alert v-if="showerror" title="Gebruikersnaam bestaat niet!" type="error" show-icon style="display:;">
</el-alert>

      </el-card>
    </el-col>

</el-row> -->
</template>
<script>
import Axios from "axios";
import { API_ROOT } from "../config";
import Cookies from "js-cookie";

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000
});

export default {
  name: "recover",
  data() {
    return {
      showrecovery: true,
      showerror: false,
      showsuccess: false,
      loading: false,
      form: {
        username: "",
        password: ""
      },
      user: Cookies.getJSON("user"),
      access: Cookies.get("user")
    };
  },
  computed: {
    // user() {
    //   return this.$store.getters.getUser;
    // },
    // loggedin() {
    //   return this.$store.getters.getLoggedin;
    // }
  },
  watch: {
    user: function(val) {
      if (this.user.access > 0) {
        if (this.user.tbl_sys_user.firstlogin) {
          this.$router.push({
            path: "/firstlogin"
          });
        } else {
          this.$message.success("Ingelogd!");
          self.$toast.open({
            message: "Ingelogd!",
            type: "is-success"
          });
          //redirect to editpage

          this.$router.push({
            path: "/okr"
          });
        }
      } else {
        self.$toast.open({
          message: "Ingelogd!",
          type: "is-dange"
        });
      }
    }
  },
  methods: {
    Back() {
      this.$router.push({
        path: "/"
      });
    },
    Recover() {
      console.log(this.form);
      console.log(this.form.password);
      var self = this;
      this.loading = true;

      instance
        .get("/login-recover/?username=" + self.form.username)
        .then(function(response) {
          var obj = response.data;

          console.log(obj);
          self.loading = false;
          if (obj.success) {
            self.$toast.open({
              message:
                "Wachtwoord is successvol gestuurd naar de geregistreerde e-mail adres!",
              type: "is-success"
            });
            self.showrecovery = false;
          } else {
            self.$toast.open({
              message:
                "Wachtwoord is successvol gestuurd naar de geregistreerde e-mail adres!",
              type: "is-danger"
            });
            self.showrecovery = true;
          }
        });
    }
  }
};
</script>
